import { IStyle, ITooltipHostStyles, classNamesFunction } from '@fluentui/react';
import { IContactUsTheme } from './theme.model';
import { color } from './themesUI';

export interface ISectionHeaderStyles {
  sectionTitle: IStyle;
  sectionDescription: IStyle;
  sectionSurfaceAppTitle: IStyle;
  premierBadge: IStyle;
  premierBadgeIcon: IStyle;
  premierBadgeText: IStyle;
  businessAssistBadge: IStyle;
  businessAssistBadgeIcon: IStyle;
  businessAssistBadgeText: IStyle;
}

export const getSectionHeaderStyles = (props: {theme: IContactUsTheme, largeFrontPageTitle?: boolean}): ISectionHeaderStyles => {
  const { theme, largeFrontPageTitle } = props;
  return {
    sectionTitle: {
      fontWeight: largeFrontPageTitle ? '600' : '700',
      fontSize: largeFrontPageTitle ? '28px' : '20px',
      lineHeight: largeFrontPageTitle ? '36px' : '28px',
      marginBottom: '5px',
      fontFamily: "'Segoe UI',SegoeUI,'Helvetica Neue',Arial,sans-serif",
      color: `${theme.palette.neutralPrimary} !important`,
    },
    sectionDescription: {
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '20px',
      fontFamily: "'Segoe UI',SegoeUI,'Helvetica Neue',Arial,sans-serif",
      color: theme.palette.neutralPrimary,
      paddingTop: largeFrontPageTitle ? '5px' : '0px',
    },
    sectionSurfaceAppTitle: {
      fontWeight: '600',
      fontSize: '28px',
      lineHeight: '36px',
      marginBottom: '5px',
      color: theme.palette.neutralPrimary,
    },
    premierBadge: {
      fontSize: '14px',
      alignSelf: 'center',
      marginLeft: 'auto',
      backgroundColor: color.yellow,
      padding: '2px 10px',
      display: 'flex',
    },
    premierBadgeIcon: {
      padding: '2px 4px 2px 0px',
      color: '#000000',
    },
    premierBadgeText: {
      verticalAlign: 'text-bottom',
      color: '#000000',
      padding: '2px 0px',
      fontFamily: "'Segoe UI',SegoeUI,'Helvetica Neue',Arial,sans-serif",
      whiteSpace: 'nowrap',
    },
    businessAssistBadge: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '4px 8px',
      backgroundColor: theme.palette.blue,
      gap: '8px',
      width: '165px',
      height: '20px',
      borderRadius: '2px',
      marginBottom: '16px',
    },
    businessAssistBadgeIcon: {
      paddingRight: '4px',
    },
    businessAssistBadgeText: {
      display: 'flex',
      fontSize: '9px',
      fontFamily: "'Segoe UI',SegoeUI,'Helvetica Neue',Arial,sans-serif",
      lineHeight: '9px',
      color: theme.palette.white,
      alignItems: 'center',
      textAlign: 'center',
      letterSpacing: '1px',
    },
  };
};

export const getBATooltipHostStyles = (): ITooltipHostStyles => {
  return {
    root: {
      display: 'inline-block',
    },
  };
};

export const getSectionHeaderClassNames = classNamesFunction<{}, ISectionHeaderStyles>();
